import React from "react";
import AdminNavbar from "../Admin/adminNavbar";
import SearchBarAdmin from "./SearchBarAdmin/SearchBarAdmin";

const FindProduct = props=>{

    return( 
        <>
           
             <SearchBarAdmin/>
        
        </> 
    )
} 

export default FindProduct 